import React from 'react';
import Box from '@mui/material/Box';
import { DeckPage, CANVAS_W, CANVAS_H } from '../components/DeckPage';
import { DeckMap } from '../components/DeckMap';

interface CoverPageProps {
  fixed?: boolean;
  backgroundImage?: string;
}

/** Deck cover: title, subtitle and a centred island map (logo is baked into the artwork). */
export const CoverPage: React.FC<CoverPageProps> = ({ fixed = false, backgroundImage }) => (
  <DeckPage fixed={fixed} pageKey="cover" background="main" backgroundImage={backgroundImage}>
    <Box sx={{ position: 'absolute', top: 150, left: 0, right: 0, textAlign: 'center' }}>
      <Box
        sx={{
          fontSize: 74,
          fontWeight: 900,
          color: '#ffffff',
          letterSpacing: 3,
          lineHeight: 1,
          textShadow: '0 3px 10px rgba(0,0,0,0.5), 0 1px 0 rgba(255,255,255,0.3)',
        }}
      >
        PROJECTS IN THE PIPELINE
      </Box>
      <Box
        sx={{
          fontSize: 38,
          fontStyle: 'italic',
          color: '#e8edf7',
          mt: 1.5,
          fontWeight: 500,
          whiteSpace: 'nowrap',
          textShadow: '0 2px 5px rgba(0,0,0,0.45)',
        }}
      >
        Upcoming{' '}
        <Box component="span" sx={{ color: '#f5d76e', fontWeight: 700 }}>
          Residential – Executive Condo – Commercial – Industrial
        </Box>{' '}
        Launches
      </Box>
    </Box>

    <svg
      width={CANVAS_W}
      height={CANVAS_H}
      viewBox={`0 0 ${CANVAS_W} ${CANVAS_H}`}
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
    >
      <DeckMap rect={{ x: (CANVAS_W - 962) / 2, y: 295, w: 962 }} mainlandOnly opacity={0.95} />
    </svg>
  </DeckPage>
);
